import * as React from 'react';

const PriceTag = props => (
  <svg
    width={114}
    height={90}
    viewBox="0 0 114 90"
    fillRule="evenodd"
    stroke="#1C1F34"
    strokeWidth={3}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#505FB4"
      d="M73.616,19.571 C70.578,19.305 68.331,16.627 68.597,13.59 C68.863,10.552 71.541,8.306 74.578,8.572 C77.615,8.838 79.863,11.515 79.597,14.552 C79.331,17.59 76.653,19.837 73.616,19.571 M89.317,30.497 L86.225,11.477 C84.839,5.324 79.097,1.159 72.819,1.752 L53.778,4.715 C50.192,5.054 46.925,6.918 44.811,9.834 L11.442,55.834 C9.888,57.976 10.365,60.971 12.506,62.524 L47.175,87.675 C49.317,89.228 52.312,88.751 53.866,86.61 L87.235,40.61 C89.35,37.695 90.109,34.01 89.317,30.497"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      d="M68.813,11.538 C69.13,14.56 67.057,17.254 64.183,17.556 C61.308,17.859 58.721,15.654 58.403,12.632 C58.085,9.61 60.158,6.915 63.033,6.613 C65.907,6.311 68.495,8.516 68.813,11.538 Z M73.141,52.984 L79.746,37.943 C79.712,37.554 79.678,37.166 79.616,36.779 L77.471,16.991 C76.265,9.748 70.164,4.549 63.267,4.809 C63.239,4.81 44.349,6.728 44.349,6.728 C43.518,6.762 42.704,6.892 41.906,7.079 C39.12,8.239 36.849,10.474 35.582,13.358 L18.76,58.611 C17.714,60.995 18.714,63.838 20.994,64.963 L47.258,87.639 L73.141,52.984 Z"
      opacity={0.300000012}
    />
    <path d="M73.616,19.571 C70.578,19.305 68.331,16.627 68.597,13.59 C68.863,10.552 71.541,8.306 74.578,8.572 C77.615,8.838 79.863,11.515 79.597,14.552 C79.331,17.59 76.653,19.837 73.616,19.571 Z M89.317,30.497 L86.225,11.477 C84.839,5.324 79.097,1.159 72.819,1.752 L53.778,4.715 C50.192,5.054 46.925,6.918 44.811,9.834 L11.442,55.834 C9.888,57.976 10.365,60.971 12.506,62.524 L47.175,87.675 C49.317,89.228 52.312,88.751 53.866,86.61 L87.235,40.61 C89.35,37.695 90.109,34.01 89.317,30.497 Z" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M78.293,18.011 C80.449,15.855 80.449,12.36 78.293,10.204 C76.137,8.048 72.642,8.048 70.486,10.204 C68.33,12.36 68.33,15.855 70.486,18.011 C72.642,20.167 76.137,20.167 78.293,18.011 Z"
    />
    <path
      stroke="#3A427C"
      d="M78.293,18.011 C80.449,15.855 80.449,12.36 78.293,10.204 C76.137,8.048 72.642,8.048 70.486,10.204 C68.33,12.36 68.33,15.855 70.486,18.011 C72.642,20.167 76.137,20.167 78.293,18.011 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M78.293,18.011 C76.137,20.167 72.642,20.167 70.486,18.011 C68.33,15.855 68.33,12.36 70.486,10.204 C72.642,8.048 76.137,8.048 78.293,10.204 C80.449,12.36 80.449,15.855 78.293,18.011 M86.97,33.771 L86.903,13.757 C86.486,7.22 81.277,2.01 74.74,1.593 L54.726,1.526 C50.993,1.288 47.337,2.668 44.692,5.313 L2.957,47.048 C1.014,48.991 1.014,52.141 2.957,54.084 L34.413,85.539 C36.356,87.482 39.506,87.482 41.449,85.539 L83.184,43.804 C85.829,41.159 87.208,37.504 86.97,33.771"
    />
    <path d="M78.293,18.011 C76.137,20.167 72.642,20.167 70.486,18.011 C68.33,15.855 68.33,12.36 70.486,10.204 C72.642,8.048 76.137,8.048 78.293,10.204 C80.449,12.36 80.449,15.855 78.293,18.011 Z M86.97,33.771 L86.903,13.757 C86.486,7.22 81.277,2.01 74.74,1.593 L54.726,1.526 C50.993,1.288 47.337,2.668 44.692,5.313 L2.957,47.048 C1.014,48.991 1.014,52.141 2.957,54.084 L34.413,85.539 C36.356,87.482 39.506,87.482 41.449,85.539 L83.184,43.804 C85.829,41.159 87.208,37.504 86.97,33.771 Z" />
    <path d="M51.581,8.587 L79.91,36.916" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#505FB4"
      d="M42.102,72.03 L38.923,68.851 C34.23,72.416 29.269,71.376 26.477,69.119 L29.269,64.545 C31.319,66.237 34.289,66.713 37.022,63.979 C38.953,62.049 39.161,60 37.853,58.692 C36.845,57.683 35.329,57.653 33.518,58.812 L30.191,60.951 C26.269,63.445 22.259,63.416 19.408,60.564 C16.259,57.416 16.379,52.664 19.052,48.98 L15.873,45.801 L18.903,42.772 L22.171,46.04 C26.21,43.247 30.072,44.138 32.477,45.712 L29.864,50.405 C28.645,49.544 26.15,48.593 23.714,51.029 C21.813,52.929 21.873,55.069 23.091,56.287 C24.012,57.208 25.438,57.327 27.131,56.227 L30.458,54.148 C35.032,51.237 38.954,51.772 41.626,54.445 C44.36,57.178 44.924,61.664 41.924,65.793 L45.132,69.001 L42.102,72.03 Z"
    />
    <path d="M44.388,49.224 L63.496,30.116" />
    <path d="M54.62,59.457 L73.728,40.349" />
    <path d="M49.504,54.34 L68.612,35.233" />
    <path d="M39.272,44.108 L58.38,25" />
    <path d="M34.156,38.992 L53.264,19.884" />
    <path d="M29.04,33.876 L48.148,14.768" />
    <path d="M74.806,12.856 C74.806,12.856 77.146,2.832 90.225,1.928 C104.856,0.916 110.833,11.997 111.939,22.751 C114.834,50.895 91.576,56.12 97.285,78.107 C97.285,78.107 99.897,87.216 107.952,88.282" />
  </svg>
);

export default PriceTag;



// WEBPACK FOOTER //
// ./src/assets/images/icons/price-tag.js